<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <AppHeader :title="$t('system_update_dates')" :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <AppHeaderMobile :title="$t('system_update_dates')" :isFilter="false"/>
            </template>

            <div class="row mt-4">
                <div class="col-12">
                    <b-card no-body class="soft">
                        <Loading :show="loading"/>
                        <b-table-simple v-if="!loading" responsive hover class="mb-0">
                            <b-thead>
                                <b-tr>
                                    <b-th>{{ $t('system') }}</b-th>
                                    <b-th>{{ $t('last_update_datetime') }}</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="system in systems" :key="system.key">
                                    <b-td>{{ $t(system.name) }}</b-td>
                                    <b-td>
                                        <span v-if="system.date">{{ formatDate(system.date) }}</span>
                                        <span v-else class="text-muted">{{ $t('no_update_information') }}</span>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-card>
                </div>
            </div>
        </app-layout>
    </div>
</template>

<script>
import moment from 'moment'
import AppLayout from '@/layouts/AppLayout'
import AppHeader from '@/layouts/AppLayout/Header'
import AppHeaderMobile from '@/layouts/AppLayout/HeaderMobile'
import Loading from '@/components/elements/Loading'
import ConstantService from '@/services/ConstantService'

export default {
    name: 'PageSystemUpdateDates',
    components: {
        AppLayout,
        AppHeader,
        AppHeaderMobile,
        Loading
    },
    data() {
        return {
            loading: false,
            systems: [
                {
                    key: 'deploy.backend_last_deploy_date',
                    name: 'backend_update_date',
                    date: null
                },
                {
                    key: 'deploy.frontend_last_deploy_date',
                    name: 'frontend_update_date',
                    date: null
                }
            ]
        }
    },
    metaInfo() {
        return {
            title: this.$t('system_update_dates')
        }
    },
    methods: {
        formatDate(date) {
            return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss')
        },
        async getUpdateDates() {
            this.loading = true

            try {
                await Promise.all(this.systems.map(async system => {
                    const response = await ConstantService.getValuePrivate(system.key)
                    system.date = response.data.data
                }))
            } catch (error) {
                this.showErrors(error)
            } finally {
                this.loading = false
            }
        }
    },
    created() {
        this.getUpdateDates()
    }
}
</script>
